
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visualize",
      function () {
        return require("private-next-pages/visualize.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visualize"])
      });
    }
  